import { React, useEffect, useState } from "react";
import styles from "../style";
import { Link } from "react-router-dom";
import { LogoName, LogoIcon, LogoName1 } from "../assets";
import { footerLinks, socialMedia, creator } from "../constants/index";
import { PiMapPinFill } from "react-icons/pi"
import { MdCall, MdEmail } from "react-icons/md";
import { motion, useMotionTemplate, useMotionValue, animate } from "framer-motion";

const COLORS = ["#e7f3ff", "#fdfaeb", "#e4f4ff", "#ffffff", "#fbffe7"]

const Footer = () => {
  const [active, setActive] = useState("Home");
  const color = useMotionValue(COLORS[0]);
  const backgroundImage = useMotionTemplate`radial-gradient(100% 100% at 90% 100%, #ffffff 60%, ${color})`;

  useEffect(() => {
    animate(color, COLORS, {
      ease: 'easeInOut',
      duration: 10,
      repeat: Infinity,
      repeatType: "mirror",
    });
  }, []);

  return (
  <motion.section 
    className={`w-full flex flex-col py-10`}
    style={{
      backgroundImage,
    }}
  >
    <div className={`w-full flex flex-col md:flex-row md:gap-40 gap-10 items-center justify-center py-20 px-10`}>
      <div className={`${styles.flexCenter} flex flex-col gap-2`}>
        <Link to="/home" className={`${styles.flexCenter} flex flex-col gap-2 mt-4`}>
          <img
            src={LogoIcon}
            alt="HSL"
            className="w-[150px] h-[150px] object-contain"
          />
          <img
            src={LogoName1}
            alt="logo"
            className="w-[120px] h-[80px] object-contain"
          />
        </Link>
        <p className={`ss:text-sm text-ss font-medium text-center max-w-[400px]`}>
          Supporting international schools
        </p>
      </div>

      <div className="flex md:flex-row flex-col items-start md:gap-4 gap-8"> 
        <div className="flex flex-row gap-6">
          {footerLinks.map((footerlink) => (
            <div key={footerlink.title} className={`flex flex-col ss:my-0 my-4 min-w-[150px]`}>
              <p className="font-semibold ss:text-sm text-ss leading-[27px] text-second">
                {footerlink.title}
              </p>
              <ul className="list-none mt-2">
                {footerlink.links.map((link, index) => (
                  <li
                    key={link.title}
                    className={`ss:text-sm text-ss leading-[24px] hover:text-second font-medium text-black cursor-pointer overflow-hidden 
                      ${index !== footerlink.links.length - 1 ? "mb-2" : "mb-0"}
                      ${active === link.title ? "text-black font-bold" : "font-medium text-black"} 
                    `}
                    
                  >
                    <Link to={link.href} onClick={() => setActive(link.title)} >{link.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex md:flex-row flex-col gap-6">
          <div className="flex flex-col gap-2">
            <p className="ss:text-sm text-ss font-semibold text-second">Connect</p> 
            <div className="flex flex-row gap-2 items-center">
              <MdCall size={18} color={'black'} />
              <p className="text-ss leading-[27px]">+254 723 493 280</p>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <MdEmail size={18} color={'black'} />
              <div className="flex flex-col">
                <p className="xs:text-sm text-ss text-start leading-[27px]">emilianne@aegiseducationgroup.com</p>
              </div>
            </div> 
            <div className="flex flex-row gap-2 items-center">
              <PiMapPinFill size={18} color={'black'} />
              <p className="ss:text-sm text-ss leading-[27px]">Ethiopia</p>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <div className={`flex flex-col gap-2`}>
              <h4 className="font-semibold ss:text-sm text-ss leading-[27px] text-second">
                Follow Us
              </h4>
              {socialMedia.map((social, index) => (
                <div className="flex flex-row gap-2 items-center">
                  <img
                    key={social.id}
                    src={social.icon}
                    alt={social.id}
                    className={`w-[18px] h-[18px] object-contain
                      ${index !== socialMedia.length - 1 ? "mr-4" : "mr-4"}
                    `} 
                  />
                  <motion.div 
                    key={social.id}
                    initial="initial"
                    whileHover="hovered" 
                    className={`relative font-medium ss:text-sm text-ss cursor-pointer overflow-hidden
                      ${active === social.title ? "text-second" : "text-black"}
                    `}
                  >
                    <motion.div 
                      variants={{
                          initial: { y: 0 },
                          hovered: { y: "-100%" },
                        }}
                      onClick={() => window.open(social.link)}
                    >
                      {social.title}
                    </motion.div>
                    <motion.div 
                      variants={{
                        initial: { y: "100%" },
                        hovered: { y: 0 },
                      }}
                      onClick={() => window.open(social.link)}
                      className="absolute inset-0"
                    >
                      {social.title}
                    </motion.div>
                  </motion.div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="w-full flex flex-col md:flex-row gap-4 items-center justify-center p-6 border-t-2 border-t-secondary">
      <p className="text-center font-medium text-ss leading-[27px]">
        Copyright Ⓒ 2026 Aegis Education Group. All Rights Reserved.
      </p> 
      {creator.map((creator, index) => (
          <div
            key={index}
            className={`font-medium cursor-pointer text-ss overflow-hidden`}
            onClick={() => window.open(creator.link)}
          >
            <p>Website by <a className="text-black underline">{creator.title}</a></p>
          </div>
        ))} 
    </div>
  </motion.section>
  )
}
export default Footer;